// extracted by mini-css-extract-plugin
export var container = "_en-0";
export var content = "_en-3";
export var customerTitle = "_en-4";
export var empty = "_en-5";
export var gray = "_en-6";
export var header = "_en-7";
export var info = "_en-8";
export var loading = "_en-2";
export var loadingCard = "_en-9";
export var oneLine = "_en-a";
export var personName = "_en-e";
export var pillContainer = "_en-b";
export var selected = "_en-1";
export var text = "_en-c";
export var twoLines = "_en-d";
export var unread = "_en-f";
export var unreadIndicator = "_en-g";